import React, { Component } from "react";
import "./style.css";
class Success extends Component {
  render() {
    const { visible,text } = this.props;
    return (
      <div
        style={visible === true ? { display: "block" } : { display: "none" }}
        className="success_hint"
      >
        <div className="success_modal">
          {text}
        </div>
      </div>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/containers/User/components/Register/components/Success/index.js